module.exports = __webpack_public_path__ + "img/sankaku_30_red.060a2e35.png";